<script setup>
const props = defineProps({
  sites: { type: Array, default: () => [] },
});

const statusLabel = {
  ready_for_shoppers: "Ready for shoppers",
  catalogue_sync_required: "Catalogue sync required",
  device_setup_required: "Device setup required",
  assign_inventory_agent: "Inventory agent required",
  activate_inventory_agent: "Activate inventory agent",
};

const actionLabel = {
  start_sync: "Start catalogue sync",
  wait_for_sync: "Catalogue updating",
  set_up_devices: "Set up devices",
  assign_inventory_agent: "Assign inventory agent",
  activate_inventory_agent: "Activate inventory agent",
};

function labelFor(site) {
  return statusLabel[site.shopper_status] || "Needs review";
}

function actionFor(site) {
  return actionLabel[site.next_action] || null;
}

function siteSetupHref(site) {
  return `/sites-devices?site=${encodeURIComponent(site.ravo_site_id)}`;
}
</script>

<template>
  <section class="shopper-readiness" aria-labelledby="shopper-readiness-heading" data-test="shopper-readiness">
    <div class="shopper-readiness__head">
      <div>
        <h3 id="shopper-readiness-heading">Shopper readiness</h3>
        <p>Catalogue and device readiness for mapped Ravo Sites.</p>
      </div>
    </div>

    <div class="shopper-readiness__rows">
      <div v-for="site in props.sites" :key="site.ravo_site_id" class="shopper-readiness__row">
        <div class="shopper-readiness__site">
          <strong>{{ site.site_name || "Ravo Site" }}</strong>
          <span v-if="site.site_location">{{ site.site_location }}</span>
          <span v-if="site.catalogue_is_updating" class="shopper-readiness__updating">Updating - shoppers keep using the last successful catalogue</span>
        </div>
        <div class="shopper-readiness__state">
          <span class="shopper-readiness__catalogue" :data-state="site.catalogue_status">
            {{ site.catalogue_status === "ready" ? "Catalogue ready" : "Catalogue not ready" }}
          </span>
          <span class="shopper-readiness__shopper" :data-state="site.shopper_status">{{ labelFor(site) }}</span>
        </div>
        <a
          v-if="actionFor(site) && site.next_action !== 'start_sync' && site.next_action !== 'wait_for_sync'"
          class="btn btn-secondary btn-sm"
          :href="siteSetupHref(site)"
          :data-test="`readiness-action-${site.ravo_site_id}`"
        >
          {{ actionFor(site) }}
        </a>
        <span v-else-if="actionFor(site)" class="shopper-readiness__action" :data-test="`readiness-action-${site.ravo_site_id}`">
          {{ actionFor(site) }}
        </span>
      </div>
    </div>
  </section>
</template>
